export const SUGGESTED_CLIP_TOOLTIP_TRANSITION_DURATION_MILLIS = 200;

export const SUGGESTED_CLIP_TOOLTIP_CLASSNAME = 'suggestedClipTooltip';
